import React from "react";
import "./App.css";
import MenuPage from "./pages/MenuPage";
import Admin from "./admin/Admin";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Login from "./admin/Login";
import AdminRoute from "./admin/AdminRoute";

const App: React.FC = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<MenuPage />} />
        <Route path="/login" element={<Login />} />
        <Route
          path="/admin"
          element={
            <AdminRoute>
              <Admin />
            </AdminRoute>
          }
        />
        <Route path="/404" element={<div>Sayfa bulunamadı.</div>} />
        <Route path="*" element={<div>Sayfa bulunamadı.</div>} />
      </Routes>
    </BrowserRouter>
  );
};

export default App;
